import { ApolloClient, InMemoryCache, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getData } from "./Utils";
import { createUploadLink } from "apollo-upload-client";

const environment = process.env.REACT_APP_ENVIRONMENT || "production";

export const uri =
  environment === "production"
    ? "https://solicitudes.multidiomasltda.com"
    : "http://localhost:4000";

const uploadLink = createUploadLink({
  uri: `${uri}/graphql`,
});

const authLink = setContext((_, { headers }) => {
  const token = getData("tokenUserMulti");
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

export const client = new ApolloClient({
  link: from([authLink, uploadLink]),
  cache: new InMemoryCache(),
});
